/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Clear_SelectionInputs */

const en_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Selection`)
};

const fr_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la sélection`)
};

const de_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl löschen`)
};

const it_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella selezione`)
};

const ru_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить выбор`)
};

const es_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar selección`)
};

const zh_cn2_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除选择`)
};

const ja_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択をクリア`)
};

const hi_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन साफ़ करें`)
};

const pt_pt2_batch_subtitle_export_clear_selection = /** @type {(inputs: Batch_Subtitle_Export_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar seleção`)
};

/**
* | output |
* | --- |
* | "Clear Selection" |
*
* @param {Batch_Subtitle_Export_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_clear_selection = /** @type {((inputs?: Batch_Subtitle_Export_Clear_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Clear_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_clear_selection(inputs)
	if (locale === "de") return de_batch_subtitle_export_clear_selection(inputs)
	if (locale === "it") return it_batch_subtitle_export_clear_selection(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_clear_selection(inputs)
	if (locale === "es") return es_batch_subtitle_export_clear_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_clear_selection(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_clear_selection(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_clear_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_clear_selection(inputs)
	return en_batch_subtitle_export_clear_selection(inputs)
});